export const ClientConstants = {
  SITES_TAB_ID_TRANSLATIONS_LOOKUP: 'common:constants.client.sites',
  SITES_PATH: '/sites',
  GROUPS_TAB_ID_TRANSLATIONS_LOOKUP: 'common:constants.client.groups',
  GROUPS_PATH: '/groups',
  BRANDS_TAB_ID_TRANSLATIONS_LOOKUP: 'common:constants.client.brands',
  BRANDS_PATH: '/brands',
  CONVERSION_WINDOW_MIN: 1,
  CONVERSION_WINDOW_MAX: 90,
};
